import router from '@/router'
import store from '@/store'
import axios from 'axios'

export const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://develop-app.monitait.com/api'

window.regranting = false

const http = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'content-type': 'application/json',
  },
})

const forceLogout = () => {
  Object.keys(localStorage).forEach((key) => localStorage.removeItem(key))
  router.push({ name: 'login' })
}

http.interceptors.request.use(
  (request) => {
    if (localStorage.getItem('access')) {
      request.headers.authorization = `Bearer ${localStorage.getItem('access')}`
    }

    return request
  },
  (err) => Promise.reject(err)
)

let isRealTimeFixed = false
const fixRealTime = (date) => {
  if (date) {
    store.commit('setCurrentTime', date)
    isRealTimeFixed = true
  }
}

http.interceptors.response.use(
  (response) => {
    if (!isRealTimeFixed) fixRealTime(response.headers.date)
    return response
  },
  (error) => {
    try {
      switch (error.response.status) {
        case 403:
        case 401:
          forceLogout()
      }
      if (store.state.alert === 'ignore' || (error.config.ignoreError && error.response.status === 404)) {
        store.state.alert = false
        return Promise.reject(error)
      }
      store.state.textAlert = ''
      if (typeof error.response.data === 'string') {
        let doc = new DOMParser().parseFromString(error.response.data, 'text/html')
        store.state.textAlert = doc.getElementsByTagName('pre')[0].textContent
      } else if (error.response.data.message) {
        store.state.textAlert = error.response.data.message
      } else if (error.response.data.detail) {
        store.state.textAlert = error.response.data.detail
      } else {
        Object.values(error.response.data).forEach((value) => {
          store.state.textAlert += value + '\n'
        })
      }
      store.state.typeAlert = 'error'
      store.state.alert = true
      return Promise.reject(error)
    } catch (err) {
      if (axios.isCancel(error)) return
      store.state.textAlert = error
      store.state.typeAlert = 'error'
      store.state.alert = true
      return Promise.reject(error)
    }
  }
)

export default http
